export default __webpack_public_path__ + "static/media/download.980ab282.svg";